import { ChipClickable, Link, TagIcon } from '@farol-ds/react'

import styles from './blog-tags.module.scss'

export interface BlogTag {
  tid: number
  title: string | null
  slug: string | null
}

export interface BlogTagsProps {
  tags: (BlogTag | null | undefined)[]
  baseUrl?: string
}

export const BlogTags = ({ tags, baseUrl = '/blog' }: BlogTagsProps) => {
  const validTags = tags.filter((tag): tag is BlogTag => !!tag && !!tag.title)

  if (validTags.length === 0) return null

  return (
    <div className={styles.tagsContainer}>
      <TagIcon />
      {validTags.map((tag) => (
        <Link key={tag.tid} href={`${baseUrl}/categoria/${tag.slug}/${tag.tid}`}>
          <ChipClickable size="md" title={tag.title || ''}>
            {tag.title}
          </ChipClickable>
        </Link>
      ))}
    </div>
  )
}
